import { useEffect, useRef } from 'react';
import { highlights } from '@/data/siteData';
import { scrollReveal, staggerFadeIn, prefersReducedMotion } from '@/hooks/useGsap';

const About = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const chipsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (sectionRef.current) {
      scrollReveal(sectionRef.current, { start: 'top 98%' });
    }
    if (chipsRef.current) {
      const chips = chipsRef.current.querySelectorAll('.chip');
      if (!prefersReducedMotion()) {
        staggerFadeIn(chips, { delay: 0.3, stagger: 0.15 });
      }
    }
  }, []);

  return (
    <section
      id="about"
      ref={sectionRef}
      className="section-padding section-atmosphere border-t border-border"
      style={{ opacity: prefersReducedMotion() ? 1 : 0 }}
    >
      <div className="container-site max-w-5xl mx-auto">
        <div className="about-layout grid gap-8 lg:grid-cols-[1fr_0.72fr] lg:items-start">
          <div>
          <span className="chip mb-4">About</span>
          <h2 className="font-display uppercase font-light text-3xl sm:text-4xl tracking-[0.03em] text-foreground mb-6">
            Halo! 👋
          </h2>
          <div className="text-sm tracking-wide text-muted-foreground space-y-4 font-sans">
            <p>
              <strong className="text-foreground">Let's Make It Easy</strong> adalah ruang belajar AI automation dari Indonesia —
              tempat teknologi kompleks dibuat simpel dan accessible buat semua orang.
            </p>
            <p>
              Pendekatan kami: <strong className="text-foreground">learn by building</strong>.
              Eksperimen, dokumentasi hasilnya, terus share biar bisa belajar bareng.
              Karena teknologi paling berguna kalau bisa dipahami banyak orang.
            </p>
            <p>
              Mission: bikin AI automation accessible buat semua orang, tidak cuma yang
              technical background.
            </p>
          </div>

          </div>

          <div className="motion-panel border border-border bg-card p-5">
            <p className="text-[10px] font-bold uppercase tracking-wider text-foreground">
              Operating principles
            </p>
          <div ref={chipsRef} className="mt-5 flex flex-wrap gap-2.5">
            {highlights.map((highlight, index) => (
              <span
                key={index}
                className="chip"
                style={{ opacity: prefersReducedMotion() ? 1 : 0 }}
              >
                {highlight}
              </span>
            ))}
          </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
